exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh5[data-v-5e1288cc] {\n  font-size: 1rem;\n  color: #6c757d;\n}\n.sortable[data-v-5e1288cc] {\n  cursor: pointer;\n}\n.sortable[data-v-5e1288cc]:hover {\n  background-color: #f5f5f5;\n}\n.btn-sm[data-v-5e1288cc] {\n    float: right;\n}\ninput[data-v-5e1288cc] {\n    margin-bottom: 12px;\n}\n", ""]);

// exports
